import { publicClient } from "@toorak/tc-common-fe-sdk";
import { getConfig } from "../config/config";

/**
 * Host OFAC transport bound to tc-bff-service proxies (plan 3 §5 / plan 6 T8).
 * Paths under `{apiUrl}/bff/ofac`:
 *   GET  /:loanId
 *   POST /status                 body: { loan_ids: string[] }
 *   GET  /:loanId/parties/:partyUid/matches
 *   POST /:loanId/review
 *   POST /:loanId/screen
 * Never calls lexis-nexis-service from the browser.
 */
export interface TcOfacTransport {
  getRollUp: (loanId: string) => Promise<any>;
  getLoanStatus: (loanIds: string[]) => Promise<any>;
  getPartyMatches: (loanId: string, partyUid: string) => Promise<any>;
  review: (loanId: string, body: unknown) => Promise<any>;
  screen: (loanId: string, body?: unknown) => Promise<any>;
}

const BFF_OFAC = "bff/ofac";

export function createTcOfacTransport(baseUrl: string = getConfig().apiUrl): TcOfacTransport {
  const root = `${baseUrl.replace(/\/$/, "")}/${BFF_OFAC}`;
  return {
    getRollUp: async (loanId) => {
      const res = await publicClient.get(`${root}/${encodeURIComponent(loanId)}`);
      return res.data;
    },
    getLoanStatus: async (loanIds) => {
      const res = await publicClient.post(`${root}/status`, { loan_ids: loanIds });
      return res.data;
    },
    getPartyMatches: async (loanId, partyUid) => {
      const res = await publicClient.get(
        `${root}/${encodeURIComponent(loanId)}/parties/${encodeURIComponent(partyUid)}/matches`
      );
      return res.data;
    },
    review: async (loanId, body) => {
      const res = await publicClient.post(
        `${root}/${encodeURIComponent(loanId)}/review`,
        body
      );
      return res.data;
    },
    // body.party_uid → BFF party-scope screen (one party, no LN keep-list prune).
    // Omit party_uid → full loan screen.
    screen: async (loanId, body = {}) => {
      const res = await publicClient.post(
        `${root}/${encodeURIComponent(loanId)}/screen`,
        body
      );
      return res.data;
    }
  };
}
